import React, { useEffect, useState } from "react";

interface AuthState {
  isAuthenticated: boolean;
  isPending?: boolean;
  profile: {
    sub?: string;
    email?: string;
    emailVerified?: string; // String "true" or "false"
  };
  providerData?: {
    accessToken?: string;
    expiresOn?: string;
    tokenType?: string;
  };
}

const Unauthorized: React.FC = () => {
  const [authState, setAuthState] = useState<AuthState | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    try {
      const authString = localStorage.getItem("auth-state");
      if (authString) {
        const auth: AuthState = JSON.parse(authString);
        setAuthState(auth);
      }
    } catch (error) {
      console.error("Error reading auth state:", error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "60vh",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            color: "#6b7280",
          }}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M21 12a9 9 0 11-6.219-8.56" />
            <animateTransform
              attributeName="transform"
              attributeType="XML"
              type="rotate"
              dur="1s"
              from="0 12 12"
              to="360 12 12"
              repeatCount="indefinite"
            />
          </svg>
          Loading...
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60vh",
        padding: "40px 20px",
        textAlign: "center",
      }}
    >
      <div
        style={{
          backgroundColor: "#fef2f2",
          borderRadius: "50%",
          padding: "20px",
          marginBottom: "24px",
        }}
      >
        <svg
          width="48"
          height="48"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#dc2626"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
          <path d="M7 11V7a5 5 0 0 1 10 0v4" />
          <line x1="12" y1="15" x2="12" y2="17" />
        </svg>
      </div>

      <h1
        style={{
          fontSize: "28px",
          fontWeight: "700",
          margin: "0 0 12px 0",
        }}
      >
        Access Denied
      </h1>

      <p
        style={{
          fontSize: "16px",
          color: "#6b7280",
          margin: "0 0 24px 0",
          maxWidth: "400px",
          lineHeight: "1.6",
        }}
      >
        You don't have authorization to access this section. This area requires
        administrator permission.
      </p>

      <div
        style={{
          backgroundColor: "#f3f4f6",
          borderRadius: "8px",
          padding: "16px 24px",
          marginBottom: "24px",
        }}
      >
        <p
          style={{
            fontSize: "14px",
            color: "#374151",
            margin: 0,
          }}
        >
          Please contact your administrator to request access.
        </p>
      </div>

      <a
        href="/"
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "8px",
          padding: "10px 20px",
          backgroundColor: "#2563eb",
          color: "white",
          borderRadius: "8px",
          textDecoration: "none",
          fontSize: "14px",
          fontWeight: "500",
          transition: "background-color 0.2s",
        }}
        onMouseOver={(e) => {
          e.currentTarget.style.backgroundColor = "#1d4ed8";
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.backgroundColor = "#2563eb";
        }}
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M19 12H5M12 19l-7-7 7-7" />
        </svg>
        Return to Home
      </a>
    </div>
  );
};

export default Unauthorized;
